





















import { message, Button, card } from '@/utilities/index';
import { PayloadContent } from "@tactful/sdk";
export default {
  props: ["buttons"],
  data() {
    return {
      detailsTitle: "",
      buyTitle: "",
      showMoreTitle: "",
    };
  },
  computed: {
    component() {
      if (this.buttons && this.buttons.length > 0 && this.buttons[0].url.includes('/payment')) {
        return 'paymentMethods';
      }
      return 'survey';
    }
  },
  methods: {
    onPostback(payload: PayloadContent, title: string) {
      this.$emit("onPostback", payload, title);
    },
    getUrl(button: Button) {
      return card.getUrl(button);
    },
    getTarget(button: Button) {
      return message.getTarget(button);
    },
    detectLang(title: string) {
      return message.detectLang(title);
    },
  }
};
